// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlayWrapper_WZEjW {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.flashOverlayWrapper_K7t_Z {
  z-index: 2;
  justify-content: flex-start;
}

.instructionCopy_SIcyq {
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  text-align: center;

  padding-top: 12px;
  padding-right: 32px;
  padding-bottom: 12px;
  padding-left: 32px;
  border-radius: 8px;
  margin-top: 20px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
}

.continueButton_pLtcI {
  position: absolute;
  bottom: max(30px, env(safe-area-inset-bottom, 30px));
  background-color: rgba(25, 78, 220, 1);
  border-style: none;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: white;
  padding: 9px 16px 9px 16px;
  min-width: 120px;
}

.continueButton_pLtcI:active {
  background-color: rgb(19, 59, 167);
  color: #c8c8c8;
  scale: .95;
}

.videoWrapper_NOcvB {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* background-color: #000; */
}

.videoWrapper_NOcvB video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  object-fit: cover;
  /* background-color: #000; */
}

.image_F5lm7 {
  object-fit: contain;
}

.squareButton_N10nK {
  margin-left: 24px;
  width: 30px;
  height: 30px;
  background-color: transparent;
  color: white;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  z-index: 1;
}

.headerSideWrapper_anVDe {
  width: 40px;
  height: 40px;
}

.squareButton_N10nK:active {
  scale: .9;
  color: whitesmoke
}

.squareButton_N10nK i {
  font-size: 20px;
}

.backButton_CH9dd {
  margin-left: 24px;
  height: 30px;
  font-weight: bold;
  background-color: transparent;
  color: white;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  z-index: 1;

}

.backButton_CH9dd:active {
  scale: .9;
  color: whitesmoke
}

.header_gLFO8 {
  height: 78px;
  background-color: rgba(0, 0, 0, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 0;
  padding-top: env(safe-area-inset-top, 0);
}

.arButtonsWrapper_QlJgh {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 150px;
}

.arButton_gxebx {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
  border: none;
  color: rgba(149, 162, 178, 1);
  width: 40px
}

.arButton_gxebx:active {
  scale: .95;
}

.arButton_gxebx:focus {
  color: rgb(64, 64, 64);
}

.arButton_gxebx:disabled {
  color: white;
}

.arButtonSquare_AFBZR, .arButtonWide_3puj8, .arButtonTall_X4CVR {
  border: 2px solid;
  border-radius: 4px;
  background-color: transparent;
 }

.arButtonSquare_AFBZR {
  height: 18px;
  width: 18px;
}

.arButtonWide_3puj8 {
  height: 15px;
  width: 20px;
}

.arButtonTall_X4CVR {
  height: 20px;
  width: 15px;
}

.aspectRatioIconWrapper_xi6MX {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  padding-bottom: 4px;
}

.frameBox_On73I {
  border-radius: 10px;
  border: 4px solid white;
  box-shadow: 0 0 0 1600px rgba(0, 0, 0, 0.5);
  transform: scale(1.05);
}

.instructionsWrapper_jjQNQ {
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 12px 12px 12px 12px;
  border-radius: 8px
}

.shutterButton_Pb5FH {
  position: absolute;
  border-radius: 1000;
  height: 50px;
  width: 50px;
  border-color: white;
  border-width: 2px;
  border-radius: 100px;
  border-style: solid;
  background-color: rgb(152, 161, 177);
  margin: 4px;
  z-index: 2;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%, 0);

}

.body_ZLHU6 {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  background-color: black;
  flex-grow: 1;
  max-height: calc(100vh - 78px - 70px);
}

::-webkit-media-controls {
  display: none !important;
}

.shutterButton_Pb5FH:active {
  border-color: rgb(49, 49, 49);
  border-width: 3px;
  background-color: rgb(236, 236, 236);
}

.fullscreenFlex_HmTut {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  padding-top: env(safe-area-inset-top, 0);
  padding-bottom: env(safe-area-inset-bottom, 0);
}


.imgContainer_FtpTr { 
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.imgContainer_FtpTr img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  object-fit: cover;
}

@media screen and (max-height: 700px) {
  .body_ZLHU6 {
    max-height: calc(100vh - 78px - 60px);
  }
  
  .shutterButton_Pb5FH {
    bottom: max(60px, env(safe-area-inset-bottom, 60px));
  }
  
  .continueButton_pLtcI {
    bottom: max(60px, env(safe-area-inset-bottom, 60px));
  }
  
  .frameBox_On73I {
    transform: scale(0.9);
  }
}
`, "",{"version":3,"sources":["webpack://./src/plugins/imageCapture/CameraScreen.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;;EAElB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,UAAU;;AAEZ;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,6BAA6B;EAC7B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;CAC9B;;AAED;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,4BAA4B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;EACZ,6BAA6B;;AAE/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,8CAA8C;AAChD;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".overlayWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.flashOverlayWrapper {\n  z-index: 2;\n  justify-content: flex-start;\n}\n\n.instructionCopy {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 26px;\n  text-align: center;\n\n  padding-top: 12px;\n  padding-right: 32px;\n  padding-bottom: 12px;\n  padding-left: 32px;\n  border-radius: 8px;\n  margin-top: 20px;\n  color: white;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.continueButton {\n  position: absolute;\n  bottom: max(30px, env(safe-area-inset-bottom, 30px));\n  background-color: rgba(25, 78, 220, 1);\n  border-style: none;\n  border-radius: 4px;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: center;\n  color: white;\n  padding: 9px 16px 9px 16px;\n  min-width: 120px;\n}\n\n.continueButton:active {\n  background-color: rgb(19, 59, 167);\n  color: #c8c8c8;\n  scale: .95;\n}\n\n.videoWrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  /* background-color: #000; */\n}\n\n.videoWrapper video {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: cover;\n  /* background-color: #000; */\n}\n\n.image {\n  object-fit: contain;\n}\n\n.squareButton {\n  margin-left: 24px;\n  width: 30px;\n  height: 30px;\n  background-color: transparent;\n  color: white;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 5px;\n  z-index: 1;\n}\n\n.headerSideWrapper {\n  width: 40px;\n  height: 40px;\n}\n\n.squareButton:active {\n  scale: .9;\n  color: whitesmoke\n}\n\n.squareButton i {\n  font-size: 20px;\n}\n\n.backButton {\n  margin-left: 24px;\n  height: 30px;\n  font-weight: bold;\n  background-color: transparent;\n  color: white;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 5px;\n  z-index: 1;\n\n}\n\n.backButton:active {\n  scale: .9;\n  color: whitesmoke\n}\n\n.header {\n  height: 78px;\n  background-color: rgba(0, 0, 0, 1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 0;\n  padding-top: env(safe-area-inset-top, 0);\n}\n\n.arButtonsWrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  width: 150px;\n}\n\n.arButton {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  color: rgba(149, 162, 178, 1);\n  width: 40px\n}\n\n.arButton:active {\n  scale: .95;\n}\n\n.arButton:focus {\n  color: rgb(64, 64, 64);\n}\n\n.arButton:disabled {\n  color: white;\n}\n\n.arButtonSquare, .arButtonWide, .arButtonTall {\n  border: 2px solid;\n  border-radius: 4px;\n  background-color: transparent;\n }\n\n.arButtonSquare {\n  height: 18px;\n  width: 18px;\n}\n\n.arButtonWide {\n  height: 15px;\n  width: 20px;\n}\n\n.arButtonTall {\n  height: 20px;\n  width: 15px;\n}\n\n.aspectRatioIconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n  padding-bottom: 4px;\n}\n\n.frameBox {\n  border-radius: 10px;\n  border: 4px solid white;\n  box-shadow: 0 0 0 1600px rgba(0, 0, 0, 0.5);\n  transform: scale(1.05);\n}\n\n.instructionsWrapper {\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 12px 12px 12px 12px;\n  border-radius: 8px\n}\n\n.shutterButton {\n  position: absolute;\n  border-radius: 1000;\n  height: 50px;\n  width: 50px;\n  border-color: white;\n  border-width: 2px;\n  border-radius: 100px;\n  border-style: solid;\n  background-color: rgb(152, 161, 177);\n  margin: 4px;\n  z-index: 2;\n  left: 50%;\n  bottom: 30px;\n  transform: translate(-50%, 0);\n\n}\n\n.body {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  background-color: black;\n  flex-grow: 1;\n  max-height: calc(100vh - 78px - 70px);\n}\n\n::-webkit-media-controls {\n  display: none !important;\n}\n\n.shutterButton:active {\n  border-color: rgb(49, 49, 49);\n  border-width: 3px;\n  background-color: rgb(236, 236, 236);\n}\n\n.fullscreenFlex {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  padding-top: env(safe-area-inset-top, 0);\n  padding-bottom: env(safe-area-inset-bottom, 0);\n}\n\n\n.imgContainer { \n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.imgContainer img {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: cover;\n}\n\n@media screen and (max-height: 700px) {\n  .body {\n    max-height: calc(100vh - 78px - 60px);\n  }\n  \n  .shutterButton {\n    bottom: max(60px, env(safe-area-inset-bottom, 60px));\n  }\n  \n  .continueButton {\n    bottom: max(60px, env(safe-area-inset-bottom, 60px));\n  }\n  \n  .frameBox {\n    transform: scale(0.9);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayWrapper": `overlayWrapper_WZEjW`,
	"flashOverlayWrapper": `flashOverlayWrapper_K7t_Z`,
	"instructionCopy": `instructionCopy_SIcyq`,
	"continueButton": `continueButton_pLtcI`,
	"videoWrapper": `videoWrapper_NOcvB`,
	"image": `image_F5lm7`,
	"squareButton": `squareButton_N10nK`,
	"headerSideWrapper": `headerSideWrapper_anVDe`,
	"backButton": `backButton_CH9dd`,
	"header": `header_gLFO8`,
	"arButtonsWrapper": `arButtonsWrapper_QlJgh`,
	"arButton": `arButton_gxebx`,
	"arButtonSquare": `arButtonSquare_AFBZR`,
	"arButtonWide": `arButtonWide_3puj8`,
	"arButtonTall": `arButtonTall_X4CVR`,
	"aspectRatioIconWrapper": `aspectRatioIconWrapper_xi6MX`,
	"frameBox": `frameBox_On73I`,
	"instructionsWrapper": `instructionsWrapper_jjQNQ`,
	"shutterButton": `shutterButton_Pb5FH`,
	"body": `body_ZLHU6`,
	"fullscreenFlex": `fullscreenFlex_HmTut`,
	"imgContainer": `imgContainer_FtpTr`
};
export default ___CSS_LOADER_EXPORT___;
